const ExportMetaData ={

    // url: "https://chitkara-events.netlify.app",
    url: "https://events.chitkara.edu.in",
    // url: 'http://localhost:3000',
    PastEvent:[
        { 
            name: "Name", key: "name", type: 'text'
        },
        {
            name: "Attendance", accessor:(object) =>
            {
                return `${object?.report && object?.report[0]?.participants ? object?.report[0]?.participants:object?.registrations?.length}`;
            },
        },
        { 
            name: "Organized By", key: "organized_by", type: 'text'
        },
        {
            name: "School", key: "brand", type: 'object'
        },
        {
            name: "Department", key: "department", type: 'object'
        },
        { 
            name: "Level of event/Activity", key: "activity", type:"select"
        },
        { 
            name: "Event Type",key:"event_type", type:"select"
        },
        {
            name: "Sub Type", key: "type", type: 'select'
        },
        { 
            name: "About", key: "about", type: 'textarea'
         },
        { 
            name: "Start Date", key: "start_date", type: 'date'
        },
        {
            name: "End Date", key: "end_date", type: 'date'
        },
        { 
            name: "Start time", key: "event_start_time", type: 'time'
        },
        {
            name:"Last Date of Registration", key:"last_registration", type:"date"
        },
        { 
            name: "Event Mode", key: "location", type: 'select'
        },
        { 
            name: "Event link", key: "eventsite", type: 'url'
        },
        {
            name: "Address", key: "address_line_1", type: 'textarea'
        },
        {
            name: "OD/Room", key: "address_line_2", type: 'textarea'
        },
        {
            name: "Country", key: "country", type: 'select'
        },
        {
            name: "State", key: "state", type: 'select'
        },
        { 
            name: "City", key: "city", type: 'text'
        },
        {
             name: "Pincode", key: "pincode", type: 'text'
        },
        { 
            name: "Event link", key: "eventsite", type: 'url'
        },
        { 
            name: "Website", key: "website", type: 'url'
        },
        { 
            name: "Facebook URL", key: "facebook", type: 'url' 
        },
        {
             name: "Linkedin URL", key: "linkedin", type: 'url'
        },
        {
            name:"SDGs", key:"sdg",  accessor:(object) =>
            {
                let sdg = object?.sdg?.map(s=>{
                  return `${s.value} `
                });
                if (typeof(sdg) == "undefined"){
                    return "-";
                }
                return `${sdg}`;
            },
        },
        {
             name:"Open Event", key:"open_event", type:"select"
        },
        { 
            name:"Registration Type", key:"registering_type", type: "select" 
        },
        {
            name:"Max Team member", key:"max_member"
        },
        {
            name:"Registration", key:"registration_type", type:"select"
        },
        { 
            name:"Fee", key:"fee", type:"text" 
        },
        { 
            name:"No. of Seats", key:"total_seats", type:"number"

        },
        {
            name: "Poster", key: "Poster", type: 'fileUpload'
        },
        {
            name: "Event Info PDF", key: "event_info", type: 'fileUploadpdf'
        },
        {
            name: "Report", accessor:(object) =>
            {
                console.log(object?.report);
                let array = [];
                for(let i=0; i<object?.report?.length; i++){
                    if(object?.report[i]?.eventWith === "Common"){
                        array.push(`${ExportMetaData.url}/eventreport/${object?.report[i]?.id}`);
                    }else if(object?.report[i]?.eventWith === "IIC"){
                        array.push(`${ExportMetaData.url}/iicreport/${object?.report[i]?.id}`);
                    }else{
                        array.push(`${ExportMetaData.url}/riseEventReport/${object?.report[i]?.id}`);
                    }
                }
                return `${array.join(",")}`;
            }
        },
        {
            name: "Certificates", accessor:(object) =>
            {
                return `${ExportMetaData.url}/templates/${object.id}/certificates`;
            }
        }  
    ],

    Registration:[
        {
            name: "Registering No.", key: "uuid", type: 'text'
        },
        { 
            name: "Fee", key: "fee", type: 'text'
        },
        { 
            name: "Registering Type", key: "registering_type", type: 'text'
        },
        {
            name: "Team", key: "team", type: 'arrayObject'
        },
        { 
            name: "Verified",key:"verified", type:"text"
        },
        {
            name: "Team Name", key: "team_name", type: 'text'
        },
    ],

    CertificateList:[
        {
            name: "Name", accessor:(object) =>{
                return object?.templateData?.TemplateName;
            }
        },
        { 
            name: "Event",accessor:(object) =>{
                return object?.template?.name;
            }
        },
        { 
            name: "Generated By",accessor:(object) =>{
               return object?.owner?.name;
            }
        },
        {
            name: "Generated To", accessor:(object) =>{
                return object?.data?.email;
            }
        },
        { 
            name: "Created At",accessor:(object) =>{
                return object?.created_at?.substr(0, 10)
            }
        },
        {
            name: "Status", accessor: (object) => {
                if(object?.bounced){
                    return 'Bounced'
                }
                return 'Sended'  
            }
        }
    ],
    
    Reportconfig:[
        {
            name: "School", key: "brandName", type: 'text'
        },
        { 
            name: "Department", key: "name", type: 'text'
        },
        { 
            name: "No. Of Event", key: "template_count", type: 'text'
        },
        {
            name: "No. Of Report", key: "report_count", type: 'text'
        },
        { 
            name: "No. Of Certificate",key:"certificate_count", type:"text"
        }
    ]
};
export default ExportMetaData;